import { useConfigStore } from '~/store/useConfigStore'

export default defineNuxtRouteMiddleware(async () => {
  const configStore = useConfigStore()
  const { config } = storeToRefs(configStore)
  const { fetchData, set } = configStore

  if (config.value) {
    return
  }

  const data = await fetchData()
  if (data) {
    set(data)
  }
})
